/** Hand-authored 16×16 pixel maps. Scale 2 → 32×32 readable demo sprites. */

const PAL = {
  ".": null,
  "#": "#1a1420",
  h: "#3b2218",
  H: "#2a140e",
  s: "#f0c8a0",
  S: "#c9926a",
  o: "#1a1420",
  e: "#f8f4e8",
  b: "#3b6fd4",
  B: "#244a9a",
  l: "#3d2f55",
  n: "#2a1c14",
  G: "#5cdb6a",
  D: "#2f8a3c",
  y: "#f8f4e8",
  w: "#c8d4e4",
  W: "#8aa0b8",
  g: "#e0b040",
  t: "#6b3d1a",
  r: "#e23b4a",
  R: "#9a1c28",
  f: "#6b5a48",
  F: "#4a3c30",
  m: "#4ec4e0",
  M: "#247a9a",
  p: "#e8f0ff",
  u: "#1e2a44",
  U: "#0f172a",
};

const HERO_IDLE = [
  "....hhhhhh......",
  "...hhhhhhhh.....",
  "...hhsssshh.....",
  "...hseosseh.....",
  "...hssSsssh.....",
  "....hssssh......",
  "....#bbbb#......",
  "...#bbbbbb#.....",
  "...#bb##bb#.....",
  "...#bbbbbb#.....",
  "....#b##b#......",
  "....ll..ll......",
  "....ll..ll......",
  "....nn..nn......",
  "....nn..nn......",
  "................",
];

const HERO_WALK_A = [
  "....hhhhhh......",
  "...hhhhhhhh.....",
  "...hhsssshh.....",
  "...hseosseh.....",
  "...hssSsssh.....",
  "....hssssh......",
  "...##bbbb##.....",
  "..s#bbbbbb#s....",
  "...#bb##bb#.....",
  "...#bbbbbb#.....",
  "....#b##b#......",
  "...ll....ll.....",
  "...ll....ll.....",
  "...nn....nn.....",
  "...nn....nn.....",
  "................",
];

const HERO_WALK_B = [
  "....hhhhhh......",
  "...hhhhhhhh.....",
  "...hhsssshh.....",
  "...hseosseh.....",
  "...hssSsssh.....",
  "....hssssh......",
  "....#bbbb#......",
  "...#bbbbbb#.....",
  "....#bbbb#......",
  "....#bbbb#......",
  "....#b##b#......",
  ".....llll.......",
  ".....llll.......",
  ".....nnnn.......",
  ".....nnnn.......",
  "................",
];

const SLIME_A = [
  "................",
  "................",
  "......GGGG......",
  "....GGGGGGGG....",
  "...GGGGGGGGGG...",
  "...GGyGGyGGGG...",
  "...GGoGGoGGGG...",
  "...GGGGGGGGGG...",
  "....GGDGGDGG....",
  ".....GGGGGG.....",
  "....GG....GG....",
  "................",
  "................",
  "................",
  "................",
  "................",
];

const SLIME_B = [
  "................",
  "................",
  "................",
  ".....GGGGGG.....",
  "...GGGGGGGGGG...",
  "...GGyGGyGGGG...",
  "...GGoGGoGGGG...",
  "...GGGGGGGGGG...",
  "....GGDGGDGG....",
  "...GGGGGGGGGG...",
  "..GG........GG..",
  "................",
  "................",
  "................",
  "................",
  "................",
];

const SWORD = [
  ".......ww.......",
  "......wWw.......",
  "......www.......",
  "......www.......",
  "......www.......",
  "......www.......",
  "......www.......",
  ".....ggggg......",
  "......ttt.......",
  "......ttt.......",
  "......ttt.......",
  "......ttt.......",
  ".......t........",
  "................",
  "................",
  "................",
];

const POTION = [
  "......yy........",
  "......##........",
  ".....####.......",
  "....#rrrr#......",
  "...#rrrrrr#.....",
  "...#rryrrr#.....",
  "...#rrrrrr#.....",
  "....#Rrrr#......",
  ".....####.......",
  "......##........",
  "................",
  "................",
  "................",
  "................",
  "................",
  "................",
];

const FLOOR = [
  "FFFFFFFFFFFFFFFF",
  "FfFfFffFFfFfFffF",
  "FffffffffffffffF",
  "FfFffFfFfFffFfFF",
  "FffffffffffffffF",
  "FFfFfFffFFfFfFfF",
  "FffffffffffffffF",
  "FfFffFFfFfFffFfF",
  "FffffffffffffffF",
  "FFfFffFfFFfFffFF",
  "FffffffffffffffF",
  "FfFfFffFFfFfFffF",
  "FffffffffffffffF",
  "FFfFfFfFFfFfFfFF",
  "FffffffffffffffF",
  "FFFFFFFFFFFFFFFF",
];

const HEART = [
  "................",
  "...rr...rr......",
  "..rrrr.rrrr.....",
  ".rrrrrrrrrrr....",
  ".rrrrrrrrrrr....",
  "..rrrrrrrrr.....",
  "...rrrrrrr......",
  "....rrrrr.......",
  ".....rrr........",
  "......r.........",
  "................",
  "................",
  "................",
  "................",
  "................",
  "................",
];

const BAR = [
  "################",
  "#uuuuuuuuuuuuuu#",
  "#urrrrrrrrrrRRu#",
  "#urrrrrrrrrRRRu#",
  "#uuuuuuuuuuuuuu#",
  "################",
  "................",
  "................",
  "................",
  "................",
  "................",
  "................",
  "................",
  "................",
  "................",
  "................",
];

const PORTRAIT = [
  "UUUUUUUUUUUUUUUU",
  "UyyyyyyyyyyyyyyU",
  "Uy............yU",
  "Uy..hhhhhh....yU",
  "Uy.hhsssshh...yU",
  "Uy.hseosseh...yU",
  "Uy.hhsssshh...yU",
  "Uy..hssssh....yU",
  "Uy...bbbb.....yU",
  "Uy...bbbb.....yU",
  "Uy............yU",
  "UyyyyyyyyyyyyyyU",
  "UUUUUUUUUUUUUUUU",
  "................",
  "................",
  "................",
];

const SLOT = [
  "################",
  "#uuuuuuuuuuuuuu#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#u............u#",
  "#uuuuuuuuuuuuuu#",
  "################",
  "................",
  "................",
];

export const PIXEL_MAPS = {
  hero_idle: HERO_IDLE,
  hero_walk_a: HERO_WALK_A,
  hero_walk_b: HERO_WALK_B,
  slime_a: SLIME_A,
  slime_b: SLIME_B,
  sword: SWORD,
  potion: POTION,
  floor: FLOOR,
  heart: HEART,
  bar: BAR,
  portrait: PORTRAIT,
  slot: SLOT,
};

export function spriteFromMap(map, { scale = 2, palette = PAL } = {}) {
  const rows = typeof map === "string" ? PIXEL_MAPS[map] : map;
  if (!rows?.length) return "";
  const h = rows.length;
  const w = rows[0].length;
  const canvas = document.createElement("canvas");
  canvas.width = w * scale;
  canvas.height = h * scale;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = false;
  for (let y = 0; y < h; y++) {
    const line = rows[y] || "";
    for (let x = 0; x < w; x++) {
      const hex = palette[line[x]];
      if (!hex) continue;
      ctx.fillStyle = hex;
      ctx.fillRect(x * scale, y * scale, scale, scale);
    }
  }
  return canvas.toDataURL("image/png");
}

export const HUD_PRESETS = [
  {
    id: "rpg",
    name: "RPG clásico",
    hint: "Corazones, barra, retrato y slots.",
    widgets: [
      { id: "hearts", type: "hearts", x: 16, y: 12, count: 5 },
      { id: "hp", type: "bar", x: 16, y: 36, w: 140, h: 12, color: "#e23b4a", label: "HP" },
      { id: "mp", type: "bar", x: 16, y: 52, w: 140, h: 8, color: "#3b6fd4", label: "MP" },
      { id: "portrait", type: "portrait", x: 16, y: 68 },
      { id: "slots", type: "slots", x: 260, y: 428, count: 5 },
      { id: "score", type: "score", x: 560, y: 14 },
    ],
  },
  {
    id: "arcade",
    name: "Arcade / Metal Slug",
    hint: "Score, vidas y arma actual.",
    widgets: [
      { id: "score", type: "score", x: 16, y: 12 },
      { id: "hearts", type: "hearts", x: 16, y: 36, count: 3 },
      { id: "weapon", type: "weapon", x: 620, y: 12 },
      { id: "slots", type: "slots", x: 300, y: 428, count: 3 },
    ],
  },
  {
    id: "gungeon",
    name: "Top-down / Gungeon",
    hint: "Corazones, moneda y arma abajo.",
    widgets: [
      { id: "hearts", type: "hearts", x: 16, y: 12, count: 4 },
      { id: "score", type: "score", x: 560, y: 12 },
      { id: "weapon", type: "weapon", x: 16, y: 420 },
      { id: "slots", type: "slots", x: 80, y: 428, count: 4 },
    ],
  },
  {
    id: "minimal",
    name: "Mínimo",
    hint: "Solo HP y score.",
    widgets: [
      { id: "hp", type: "bar", x: 16, y: 16, w: 160, h: 10, color: "#e23b4a", label: "HP" },
      { id: "score", type: "score", x: 560, y: 14 },
    ],
  },
];

export const HUD_WIDGET_TYPES = [
  { id: "hearts", label: "Corazones" },
  { id: "bar", label: "Barra HP/MP" },
  { id: "portrait", label: "Retrato" },
  { id: "score", label: "Score" },
  { id: "slots", label: "Slots" },
  { id: "weapon", label: "Arma actual" },
  { id: "boss", label: "Barra de boss" },
];

export function defaultHud(presetId = "rpg") {
  const p = HUD_PRESETS.find((x) => x.id === presetId) || HUD_PRESETS[0];
  return {
    preset: p.id,
    widgets: p.widgets.map((w) => ({ ...w })),
  };
}

export function buildDemoSprites() {
  const mk = (name, map, extra = {}) => ({
    id: extra.id || (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `spr_${name}`),
    name,
    data_url: spriteFromMap(map),
    width: 32,
    height: 32,
    role: "starter",
    ...extra,
  });
  const hero = mk("Hero", "hero_idle", { category: "character", studio: "creatures", subtype: "hero", tags: ["hero", "mc"] });
  const heroA = mk("Hero_walk_a", "hero_walk_a", { category: "character", studio: "creatures", subtype: "hero", tags: ["hero", "walk"] });
  const heroB = mk("Hero_walk_b", "hero_walk_b", { category: "character", studio: "creatures", subtype: "hero", tags: ["hero", "walk"] });
  const slime = mk("Slime", "slime_a", { category: "mob", studio: "creatures", subtype: "mob", tags: ["mob", "creature"] });
  const slimeB = mk("Slime_walk_b", "slime_b", { category: "mob", studio: "creatures", subtype: "mob", tags: ["mob"] });
  const sword = mk("Espada", "sword", { category: "weapon", studio: "gear", subtype: "longsword", tags: ["weapon", "espada"] });
  const potion = mk("Pocion", "potion", { category: "item", studio: "gear", subtype: "potion", tags: ["item", "consumible"] });
  const floor = mk("Piso_piedra", "floor", { category: "tileset", studio: "world", subtype: "floor", tags: ["tile"] });
  const heart = mk("HUD_heart", "heart", { category: "heart", studio: "hud", subtype: "heart" });
  const bar = mk("HUD_bar", "bar", { category: "bar", studio: "hud", subtype: "bar" });
  const portrait = mk("HUD_retrato", "portrait", { category: "portrait", studio: "hud", subtype: "portrait" });
  return {
    sprites: [hero, heroA, heroB, slime, slimeB, sword, potion, floor, heart, bar, portrait],
    hero, slime, sword, potion, floor,
    animations: [
      {
        id: typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : "anim-hero",
        name: "Héroe caminar",
        fps: 8,
        studio: "creatures",
        frames: [
          { data_url: hero.data_url, w: 32, h: 32 },
          { data_url: heroA.data_url, w: 32, h: 32 },
          { data_url: heroB.data_url, w: 32, h: 32 },
        ],
      },
      {
        id: typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : "anim-slime",
        name: "Slime bounce",
        fps: 6,
        studio: "creatures",
        frames: [
          { data_url: slime.data_url, w: 32, h: 32 },
          { data_url: slimeB.data_url, w: 32, h: 32 },
        ],
      },
    ],
  };
}
